export default "__VITE_ASSET__CpDblTtX__"